export default class ErrorHandler {
    constructor(component) {
        this.component = component;
    }

    processError(error) {
        this.component.props.history.push({
            pathname: "/error",
            state: {
                from : this.component.props.history.location.pathname
            },
        });
    }
}
